import React from 'react';
import {connect}  from 'react-redux';
import { Formik, getIn } from 'formik';
import * as yup from 'yup';
import { Form, Row, Col, Collapse, Card} from 'react-bootstrap';
import Stats from '../Stats';
import NumberFormat from '../NumberFormat';

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
const schema = yup.object().shape({
    email: yup.string().email('This must be a valid email').required('Please enter your email'),
    phone: yup.string().matches(phoneRegExp, 'Please enter a valid phone number')
  });
// const initialValues = {
//     email:'',
//     phoneNumber:''
// };
class Step9 extends React.Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
  handleSubmit(values,props) {
    // console.log('---here are values',values);
    let client = this.props.form.client;
    client.email = values.email;
    client.phone = values.phone;
    this.props.upliftState({client},'client');
    this.props.processResult('generate');
    return;
  }
   
  render() {
     
    return(
                 <Formik
                    validateOnChange={false}
                    validateOnBlur={false}
                    initialValues={this.props}
                    validationSchema={schema}
                    onSubmit={this.handleSubmit}
                >
                {({
                        handleSubmit,
                        handleChange,
                        setFieldValue,
                        setFieldTouched,
                        handleBlur,
                        values,
                        errors,
                        touched,
                        isSubmitting
                    }) => (
                        <Form onSubmit={handleSubmit} >
                            <Card className="stepChild">
                            <Card.Header>
                                <Row >
                                <span style={{'position':'absolute','paddingLeft':'15px'}}><strong>9.</strong></span>
                                    <Col md={"10"} sm={"12"} style={{'paddingLeft':'35px'}}>
                                        {this.props.getStepHeader(9) } 
                                    </Col>
                                    <Col md={"2"} sm={"12"}>
                                        <Stats type="edit" step={9} {...this.props} />
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Collapse in={this.props.isActive}>
                            <Card.Body>
                             <Form.Row>
                            <Form.Group as={Col} md="6" controlId="validationFormikEmail">
                            <Form.Label className="required">Email</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={getIn(values, `email`)}
                                    onChange={e => {setFieldValue( `email`,e.target.value);
                                    setFieldTouched( `email`,true);}}
                                    isValid={getIn(touched, `email`) && !getIn(errors, `email`)}
                                    isInvalid={getIn(errors, `email`) }
                                />
                                <Form.Control.Feedback type="invalid">
                                    { getIn(errors, `email`) }
                                </Form.Control.Feedback> 
                            </Form.Group>
                            <Form.Group as={Col} md="6" controlId="validationFormikPhone">
                            <Form.Label>Telephone</Form.Label>
                                <NumberFormat
                                value={values.phone} 
                                format="###-###-####"
                                onValueChange={e => {  setFieldValue( 'phone', e.floatValue);
                                            setFieldTouched( 'phone',true);  }}
                                error={ getIn(errors,'phone') }
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col} md="12" style={{"padding":"0px","margin":"0px"}} controlId="step9Continue">
                                <Col md={"12"} sm={"12"}>
                                    <Stats type='continue' step={9} {...this.props} />
                                </Col>
                            </Form.Group>
                        </Form.Row>
                        </Card.Body>
                        </Collapse>
                        </Card>
                        </Form>
                    )}
                    </Formik>
    );
   }
}
const mapStateToProps = (state , ownProps) => {
    let {form} = state.mainState;
    let {client,scenario} = form;
        if(!client.isMarried || client.isMarried === 'false'){
            client.spouse = {};
            scenario.spouse = {employment:{}};
        }
        return {
            form,
            email: client.email,
            phone: client.phone,
            isMarried:client.isMarried,
            scenario,
            ...ownProps
        }
  }
 export default connect(
    mapStateToProps,
    null
    )(Step9)